/**
 * The facet keys and values the company list's filter rail is built from.
 *
 * Internal identifiers, never shown - the headings the rail renders come from `filterFacets` in
 * `view-groups.ts` and, where the concept is a domain one, from the glossary.
 *
 * THEY LIVE IN THEIR OWN MODULE BECAUSE THE JOURNEYS ADDRESS THE RAIL BY THEM. A journey that
 * retyped `'types'` would keep compiling after a rename and fail on a timeout naming a missing
 * checkbox rather than naming the rename - the same argument that makes those journeys read
 * `operatingStatusLabel` instead of the word "Active".
 *
 * Kept out of `view-groups.ts` for a mechanical reason as well as a design one: the Playwright
 * suite is type-checked under `tsconfig.e2e.json`, which is Node-side and carries no Vite client
 * types, so importing the page itself would pull the whole application graph - `?inline`
 * stylesheets, `import.meta.env` and all - into a compilation that cannot resolve any of it. A leaf
 * module with no imports of its own is safe to read from either side.
 */

export const FACET_OPERATING = 'operating';
export const FACET_MEMBERSHIP = 'membership';
export const FACET_TYPES = 'types';

/**
 * Values of the operating-state facet.
 *
 * `'blocked'`, not the `'inactive'` the old radio group carried. The word on screen has been
 * "Blocked" since `operatingStatusLabel` was introduced, and an identifier that disagrees with the
 * label it renders is a trap for the next person reading the filter state in a debugger. This is a
 * new control with new values rather than a rename of a persisted one, so nothing has to migrate.
 */
export const OPERATING_ACTIVE = 'active';
export const OPERATING_BLOCKED = 'blocked';
